// extracted by mini-css-extract-plugin
export default {"btn":"InfoButton_btn__iKKIX"};